import { Room } from './types';

const ROOM_PATH = /^\/rooms\/([^/]+)\/?$/i;

export function roomNameSlug(name: string): string {
  return name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function roomPath(room: Room): string {
  return `/rooms/${roomNameSlug(room.name)}`;
}

export function roomFromPath(rooms: Room[], pathname: string): Room | null {
  const match = pathname.match(ROOM_PATH);
  if (!match) return null;

  let routeValue: string;
  try {
    routeValue = decodeURIComponent(match[1]).toLowerCase();
  } catch {
    return null;
  }

  const byName = rooms.find(room => roomNameSlug(room.name) === routeValue);
  if (byName) return byName;

  if (/^\d+$/.test(routeValue)) {
    const decimalId = Number(routeValue);
    const byDecimalId = rooms.find(room => room.roomId === decimalId);
    if (byDecimalId) return byDecimalId;
  }

  const hexId = routeValue.replace(/^0x/, '');
  if (/^[0-9a-f]+$/.test(hexId)) {
    return rooms.find(room => room.roomIdHex.slice(2).toLowerCase() === hexId) ?? null;
  }

  return null;
}
